import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of plans.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListPlanPage - Lazy-loaded ListPlanPage component.
 */
const ListPlanPage = Loadable(lazy(() => import("./ListPlanPage")));

/**
 * Lazy-loaded component for rendering the add plan page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddPlanPage - Lazy-loaded AddPlanPage component.
 */
const AddPlanPage = Loadable(lazy(() => import("./AddPlanPage")));

/**
 * Lazy-loaded component for rendering the View plan page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewPlanPage - Lazy-loaded ViewPlanPage component.
 */
const ViewPlanPage = Loadable(lazy(() => import("./ViewPlanPage")));

/**
 * Lazy-loaded component for rendering the View plan page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewPlanPage - Lazy-loaded ViewPlanPage component.
 */
const EditPlanPage = Loadable(lazy(() => import("./EditPlanPage")));

/**
 * Array containing route definitions for the plan-related pages.
 * @constant {Object[]} PlanRoutes - Array of plan route objects.
 * @property {string} PlanRoutes[].path - The path of the plan route.
 * @property {React.ReactElement} PlanRoutes[].element - The React element to be rendered for the plan route.
 */
const PlanRoutes = [
  {
    path: "list",
    element: <ListPlanPage />,
  },
  {
    path: "add",
    element: <AddPlanPage />,
  },
  {
    path: "view/:plan_id",
    element: <ViewPlanPage />,
  },
  {
    path: "edit/:plan_id",
    element: <EditPlanPage />,
  },
];

export default PlanRoutes;
